import { default as ax } from "axios";
import VueCookies from "vue-cookies";

let axios = ax.create({
    baseURL: `${process.env.VUE_APP_BLACKBOX_API_BASE_URL}`,
});

axios.interceptors.request.use(
    (config) => {
        let token = VueCookies.get("saas-token");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
            /*
            To keep some apis working ex(case list api) which dependes upon some header values,
            use this function.
            */
            // config.headers["X-Source"] = `(saas-platform) ${APP_CONFIG.name}/${APP_CONFIG.version}`;
            // config.headers["X-User-ID"] = store.getters.getUserAuthDetails.userId;
            // config.headers["X-CASE-ID"] = store.getters.getCaseId == null ? "" : store.getters.getCaseId;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axios;
